module.exports = __webpack_public_path__ + "static/media/Imageneon.4d32896e.png";